import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { SessionRequestType } from "../../utils";
import type { DappRpcRequest } from "../../types";

export interface DappModalState {
  modalType: SessionRequestType | null;
  currentRequest: DappRpcRequest | null;
}

const initialState: DappModalState = {
  modalType: null,
  currentRequest: null,
};

const dappModalSlice = createSlice({
  name: 'dappModal',
  initialState,
  reducers: {
    showRequest(state, action: PayloadAction<DappRpcRequest>) {
      state.modalType = action.payload.type;
      state.currentRequest = action.payload;
    },
    clear(state) {
      state.modalType = null;
      state.currentRequest = null;
    },
  },
});

export const dappModalActions = dappModalSlice.actions;
export const dappModalReducer = dappModalSlice.reducer;